export default "__VITE_ASSET__DmXlHdia__"